import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { Inject, Injectable, Injector } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { RolePermissionModel } from '@core/models/identidade/role-permission.model';
import { LocalStorageService } from 'ngx-webstorage';
import { Variables } from '@core/utils/variables';
import { RoleModel } from '@core/models/identidade/role.model';

export class PermissionStorageModel {

  permissions?: RolePermissionModel[];
  user?: string;

  constructor(options: PermissionStorageModel = {}) {
    this.permissions = options.permissions || [];
    this.user = options.user || null;
  }
}
@Injectable({
  providedIn: 'root',
})
export class UserPermissionsService {

  private _permissionsSubject$ = new BehaviorSubject<RolePermissionModel[]>(new Array<RolePermissionModel>());
  private _rolesSubject$ = new BehaviorSubject<RoleModel[]>(new Array<RoleModel>());

  constructor(
    private _storage: LocalStorageService
  ) { }

  clear(): void {
    this._storage.clear(Variables.PERMISSIONS);
    this._storage.clear(Variables.ROLES);
  }

  getPermissionsList(): RolePermissionModel[] {
    return this._permissionsSubject$.getValue();
  }

  getPermissions(): Observable<RolePermissionModel[]> {
    return this._permissionsSubject$.asObservable();
  }

  getRoleList(): RoleModel[] {
    return this._rolesSubject$.getValue();
  }

  getRoles(): Observable<RoleModel[]> {
    return this._rolesSubject$.asObservable();
  }

  recoverFromStorage(): void {
    let storagePermissions = this._storage.retrieve(Variables.PERMISSIONS);
    let storageRoles = this._storage.retrieve(Variables.ROLES);
    let permissions: RolePermissionModel[] = storagePermissions ? storagePermissions.permissions : new Array<RolePermissionModel>();
    let roles: RoleModel[] = storageRoles ? storageRoles : new Array<RoleModel>();
    this.setPermissionsSubject(permissions);
    this.setRolesSubject(roles);
  }

  setPermissionsSubject(permissions: RolePermissionModel[]): void {
    this._permissionsSubject$.next(permissions);
  }

  setPermissionsStorage(permissions: PermissionStorageModel): void {
    this._storage.store(Variables.PERMISSIONS, permissions);
  }

  setRolesSubject(roles: RoleModel[]): void {
    this._rolesSubject$.next(roles);
  }

  setRoleStorage(roles: RoleModel[]): void {
    this._storage.store(Variables.ROLES, roles);
  }
}
